import React, { FunctionComponent, useEffect } from 'react';
import { RowContainer } from './InfoBlock';
import { useMessageGetter } from 'react-message-context';
import { useKennoTenant } from '../../../context/kennoTenantContext';
import { loadBuilding } from '../../../context/kennoTenantActions';

const SafetyAndEvacuation: FunctionComponent = () => {
  const [{ building }, dispatch] = useKennoTenant();
  const t = useMessageGetter('housing');

  useEffect(() => {
    loadBuilding(dispatch);
  }, [dispatch]);

  const emergencyPlanUrl = building.data?.emergencyPlan.url || null;

  return (
    <dl>
      <RowContainer>
        <dt>{t('emergencyplan.documentname')}</dt>
        <dd>
          {emergencyPlanUrl ? (
            <>
              {`${t('open')} `}
              <a href={emergencyPlanUrl} target="_blank" rel="noopener noreferrer">
                {t('emergencyplan.documentname')}
              </a>
            </>
          ) : (
            t('noexist.emergencyplan')
          )}
        </dd>
      </RowContainer>
    </dl>
  );
};

export default SafetyAndEvacuation;
